import { Typography } from '@mui/material'
import { Intersect } from '@phosphor-icons/react'
import type { Plate } from 'metalworks-domain'
import { Hole } from 'metalworks-domain'

import type { DomainEntityId } from '@salsita-ai/platform-project-sdk/domain'
import { EntityChildrenList } from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer, TooltipWithArrow } from '@salsita-ai/platform-project-sdk/ui'

import { configuratorInterface } from '../systems/configurator-interface'

const ConflictIcon = (props: { entityId: Hole['id'] }) => {
  const { entityId } = props
  const { domain } = configuratorInterface.useDomain()

  const $plate = configuratorInterface.useStoreSelector(({ state }) => domain.getRoot$Entity(state), [])

  const isFeatureOverlapping = $plate.$allOverlappingFeatureIds.includes(entityId)
  if (!isFeatureOverlapping) {
    return null
  }

  return (
    <TooltipWithArrow title="This feature is overlapping" placement="left" enterDelay={300}>
      <Intersect size={26} color="red" />
    </TooltipWithArrow>
  )
}

const EntityChildrenActions = (props: { entityId: DomainEntityId<string> }) => {
  const { entityId } = props

  if (!Hole.isId(entityId)) {
    return <></>
  }

  return <ConflictIcon entityId={entityId} />
}

export const FeatureList = ({ entityId }: { entityId: Plate['id'] }) => {
  const { domain } = configuratorInterface.useDomain()
  const $plate = configuratorInterface.useStoreSelector(({ state }) => domain.getRoot$Entity(state), [])

  return (
    <PropertyContainer.Group spacing="large">
      <PropertyContainer.Item title="Existing Features">
        {$plate.$holes.length > 0 ? (
          <>
            {$plate.$allOverlappingFeatureIds.length > 0 ? (
              <Typography variant="body2" sx={{ mb: 1 }}>
                One or more features are overlapping.
              </Typography>
            ) : null}
            <EntityChildrenList entityId={entityId} relation="$holes" Actions={EntityChildrenActions} />
          </>
        ) : (
          <Typography variant="body2">No features added to the plate yet.</Typography>
        )}
      </PropertyContainer.Item>
    </PropertyContainer.Group>
  )
}
